module.exports = __webpack_public_path__ + "img/title-bg.ead39b54.png";